import { CHAT_COLUMN_MAX_WIDTH } from '@fruitful/agent-ui';
import React, { type ReactNode } from 'react';
import { YStack, type YStackProps } from 'smoothie';

interface ChatColumnProps extends YStackProps {
    children: ReactNode;
}

export const ChatColumn = ({ children, ...stackProps }: ChatColumnProps) => {
    return (
        <YStack
            width="100%"
            maxWidth={CHAT_COLUMN_MAX_WIDTH}
            overflow="visible"
            {...stackProps}
        >
            {children}
        </YStack>
    );
};
